var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.function.name", "react", "prop-types", "./Logo.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.function.name"), require("react"), require("prop-types"), require("./Logo.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Function, global.react, global.propTypes, global.Logo);
    global.Logo = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Function, _react, _propTypes, _Logo) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  var Logo = function Logo(_ref) {
    var className = _ref.className,
        color = _ref.color,
        name = _ref.name,
        size = _ref.size,
        title = _ref.title,
        vertical = _ref.vertical;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, title && /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, title), /*#__PURE__*/_react.default.createElement(_Logo.StyledSvg, {
      aColor: color,
      "aria-hidden": true,
      className: className,
      focusable: "false",
      size: size,
      tabIndex: -1,
      vertical: vertical
    }, /*#__PURE__*/_react.default.createElement("use", {
      xlinkHref: "#".concat(name)
    })));
  };

  Logo.propTypes = {
    className: _propTypes.default.string,
    color: _propTypes.default.string,
    name: _propTypes.default.string.isRequired,
    size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xxsmall', 'xsmall', 'small', 'mediumSmall', 'medium', 'large', 'xlarge', 'xxlarge']), _propTypes.default.shape()]),
    title: _propTypes.default.string,
    vertical: _propTypes.default.bool
  };
  Logo.defaultProps = {
    className: '',
    color: 'mainColor',
    name: '',
    size: 'medium',
    title: '',
    vertical: false
  };
  var _default = Logo;
  _exports.default = _default;
});